export const NO_TEMPLATE_SELECTED_TEXT = {
    id: `oe.templates.noTemplateSelected`,
    description: 'Label text',
    defaultMessage: 'No Template Selected',
};

export const CONNECTION_VERSION_TEXT = {
    message: 'V2 connections are {suffix}',
    id: 'oe.templates.meeting.connectionVersion',
    description: 'Label text',
};

export const DEFAULT_MEETING_TEMPLATE_EXPLENATION = {
    defaultMessage: 'The default template will be set when the New Meeting pop up is opened. User will be able to change or remove it before creating the meeting.',
    id: 'oe.templates.meeting.defaultMeetingTemplateExplenation',
    description: 'Label text',
};

export const DEFAULT_MEETING_TEMPLATE_TEXT = {
    id: 'oe.blueprints.event.defaultMeetingBlueprintId',
    defaultMessage: 'Default Meeting Template',
    description: 'Label text'
};